import { render, staticRenderFns } from "./organizeAgreement.vue?vue&type=template&id=4353f997&scoped=true&"
import script from "./organizeAgreement.vue?vue&type=script&lang=js&"
export * from "./organizeAgreement.vue?vue&type=script&lang=js&"
import style0 from "./organizeAgreement.vue?vue&type=style&index=0&id=4353f997&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4353f997",
  null
  
)

export default component.exports